import type { ExternalItemFormSchema } from '@/packages/subsidy/pages/refund-request/steps/resource-description/steps/external-item-form/components/learning-aid/schema';

interface CourseResourcePayloadParams {
  formValues?: ExternalItemFormSchema | null;
  resourceType: string;
}

export const aidResource = ({
  formValues,
  resourceType,
}: CourseResourcePayloadParams) => {
  return {
    type: resourceType,
    name: formValues?.name,
    request_reason: formValues?.request_reason ?? '',
    link: formValues?.link ?? '',
    amount: formValues?.amount ?? 0,
    sale_type: formValues?.sale_type ?? '',
  };
};
